import { IApplication } from 'src/IApplication';

export const applications: Record<string, IApplication> = {
  AppBuilder: {
    title: 'App Builder',
    description: 'Build your own website',
    icon: '/app-images/apps-icon.svg',
    name: 'App Builder',
    hidden: false,
    route: '/web-builder',
    modules: {
      module1: {
        name: 'Pages',
        route: '/pages',
        title: 'Pages',
        hidden: false,
        isDropdown: false
      },
      module2: {
        name: 'Images',
        route: '/images',
        title: 'Images',
        hidden: false,
        isDropdown: false
      },
      module3: {
        name: 'Users',
        route: '/users',
        title: 'Users',
        hidden: false,
        isDropdown: false
      },
      module4: {
        name: 'News',
        route: '/news',
        title: 'News',
        hidden: false,
        isDropdown: false
      },
      module5: {
        name: 'Jobs',
        route: '/jobs',
        title: 'Jobs',
        hidden: false,
        isDropdown: false
      },
      module6: {
        name: 'Configurations',
        route: '/config_listing',
        title: 'Configurations',
        hidden: false,
        isDropdown: false
      }
    }
  }
};
